/**
 * API Endpoints to handle Custom pages.
 * Text are editable only by admins, therefore is trustable.
 */
import Axios, { type AxiosRequestConfig } from "axios";

type CustomPageType = {
  language: string;
  text: TrustedHTML;
};

export type UserGuideType = {
  id: number;
  title: string;
  code?: string | null;
  description: TrustedHTML;
  category: string | null;
  category_id?: number | null;
  category_code?: string | null;
  language: string;
  file_size: number | null;
  uploaded_at: string | null;
};

export type UserGuidePdf = {
  title: string;
  view_url: string;
};

const getCustomPage = async (url: string, language?: string, config?: AxiosRequestConfig) => {
  config = config || {};
  config.params = language ? { lang: language } : undefined;
  const response = await Axios.get<CustomPageType>(url, config);
  return response.data;
};

export const getPrivacyPolicy = async (language?: string, config?: AxiosRequestConfig) => {
  return await getCustomPage("/api/custom-pages/privacy-policy/", language, config);
};

export const getTermsAndConditions = async (language?: string, config?: AxiosRequestConfig) => {
  return await getCustomPage("/api/custom-pages/terms-and-conditions/", language, config);
};

export const getUserGuides = async (config?: AxiosRequestConfig) => {
  const response = await Axios.get<UserGuideType[]>("/api/user-guides/", config);
  return response.data;
};

export const getUserGuidePdf = async (id: number | string, config?: AxiosRequestConfig) => {
  const response = await Axios.get<UserGuidePdf>(`/api/user-guides/${id}/view-url/`, config);
  return response.data;
};
